import React from 'react';
import axios from 'axios';
import Conf from './Conf';

class Auth extends React.Component {
    // state = {};
    componentDidMount(){
        var url = window.location.href.split("?ref=");
        if(url[1] && url[1]!==''){
            axios.get(Conf.authURL+'token/'+url[1]).then(res=>{
                if(res.data.token && res.data.token!==""){
                    axios.get(Conf.authURL+'me',{headers:{'Authorization':res.data.token,'X-Requested-With':'profile'}}).then(res2=>{
                        console.log(res2.data.profile.usn)
                        axios.get(Conf.backendURL+'user',{headers:{'Authorization':res2.data.profile.usn}}).then(res3=>{
                            
                            if(res3.data.usn){
                                var cookie = {
                                    token : res.data.token
                                }
                                var callback = localStorage.getItem(Conf.cookieName);
                                callback = JSON.parse(callback);
                                localStorage.setItem(Conf.cookieName,JSON.stringify(cookie));                                
                                if(callback && callback.callback) window.location = callback.callback;
                                else window.location = process.env.PUBLIC_URL+"/";
                            }else this.goLogin();
                        });
                    })
                }else this.goLogin();
            })
        }else this.goLogin();
    }
    goLogin(){
        window.location.href=Conf.frontendURL+"login";
    }
    render(){
        return (
            <div>{/* <a href="http://localhost:3000/epayment/login">AUTH</a> */}
            </div>
        );
    }
}

export default Auth;
